import { apiClient } from "@/lib/apiClient";
import type { IGetMoleculeDetailsResponse } from "./interfaces";

export const getMoleculeDetails = async (
  bsadbId: string,
): Promise<IGetMoleculeDetailsResponse> => {
  const { data } = await apiClient.get<IGetMoleculeDetailsResponse>(
    `/data/molecule/${encodeURIComponent(bsadbId)}`,
  );
  return data;
};
